import { Inject, Injectable } from "@angular/core";
import { DwDataRequest, DwDatasource, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwOrmDataSource, DwQuery, DwSecurityUserService } from "@devwareapps/devware-cap";
import { AppMetaData, AppMetaDataItemNames } from "../../../meta-data/app-meta-data.service";
import { AppDevwareBootstrapService } from "src/app/app-devware-registrations.service";
import { AssignmentStudentDataSourceService } from "./assignment-student-data-source.service";

@DwDatasource({
    keyName: 'AssignmentStudentHomePageDataSource',
    display: 'Assignment Student Home Page List Data Source',
    itemName: AppMetaDataItemNames.Assignment,
})
@Injectable()
export class AssignmentStudentHomePageDataSourceService extends AssignmentStudentDataSourceService {

    prepareRequestQuery(request: DwDataRequest): DwQuery {
        const assignmentQuery = this.buildAssignmentQuery(request, true);

        // Limit to 3 assignments
        assignmentQuery.PagingInfo = {
            Top: 3,
            PageNo: 1,
            PageSize: 10,
        };

        return assignmentQuery;
    }

}